// =============================================================================
// MATRIX "Value chain dimension" — Reale Group 2025 (pag. 83)
// English copy of matriceCatenaValore.js — icon codes are IDENTICAL to the IT
// data (recently corrected). Only human-readable strings are translated.
//
// Icon legend:
//   P = Positive (green face)   N = Negative (red face)
//   O = Opportunity (blue sun)  R = Risk (blue triangle)
//   []   = empty cell
//   "NA" = "not applicable" (covers Impact+Financial for that dimension)
//
// Each dimension has { impact: [...], financial: [...] } or "NA".
// =============================================================================

export const DIMENSIONI = [
  { key: "fornitori",         label: "Suppliers",       banda: "UPSTREAM" },
  { key: "operazioniProprie", label: "Own operations",  banda: "MIDSTREAM" },
  { key: "sottoscrizione",    label: "Underwriting",    banda: "DOWNSTREAM" },
  { key: "credito",           label: "Credit",          banda: "DOWNSTREAM" },
  { key: "investimenti",      label: "Investments",     banda: "DOWNSTREAM" },
  { key: "distributori",      label: "Distributors",    banda: "DOWNSTREAM" },
];

export const LEGENDA = {
  P: "Positive",
  N: "Negative",
  O: "Opportunity",
  R: "Risk",
};

// Rows: ESRS theme -> sub-topics, each with the 6 dimensions
export const MATRICE = [
  {
    tema: "ESRS E1 — Climate change",
    sottotemi: [
      {
        sottotema: "Climate change mitigation",
        celle: {
          fornitori:         { impact: ["N"],      financial: [] },
          operazioniProprie: { impact: ["N", "P"], financial: ["R"] },
          sottoscrizione:    { impact: ["N", "P"], financial: ["R"] },
          credito:           { impact: ["N"],      financial: ["R"] },
          investimenti:      { impact: ["N", "P"], financial: ["R"] },
          distributori:      { impact: [],         financial: [] },
        },
      },
      {
        sottotema: "Climate change adaptation",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: ["N", "P"], financial: ["R"] },
          sottoscrizione:    { impact: ["N"], financial: ["R"] },
          credito:           { impact: ["N"], financial: ["R"] },
          investimenti:      { impact: [],    financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS E4 — Biodiversity and ecosystems",
    sottotemi: [
      {
        sottotema: "(single topic)",
        celle: {
          fornitori:         { impact: ["N"], financial: [] },
          operazioniProprie: { impact: [], financial: [] },
          sottoscrizione:    { impact: ["N"], financial: [] },
          credito:           { impact: ["N"], financial: [] },
          investimenti:      { impact: ["N"], financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS S1 — Own workforce",
    sottotemi: [
      {
        sottotema: "Working conditions",
        celle: {
          fornitori:         "NA",
          operazioniProprie: { impact: ["N", "P"], financial: ["N", "O"] },
          sottoscrizione:    "NA",
          credito:           "NA",
          investimenti:      "NA",
          distributori:      "NA",
        },
      },
      {
        sottotema: "Equal treatment and opportunities for all",
        celle: {
          fornitori:         "NA",
          operazioniProprie: { impact: ["N", "P"], financial: ["R"] },
          sottoscrizione:    "NA",
          credito:           "NA",
          investimenti:      "NA",
          distributori:      "NA",
        },
      },
    ],
  },
  {
    tema: "ESRS S2 — Workers in the value chain",
    sottotemi: [
      {
        sottotema: "Working conditions",
        celle: {
          fornitori:         { impact: ["N"],      financial: ["R"] },
          operazioniProprie: "NA",
          sottoscrizione:    { impact: ["N"],      financial: ["R"] },
          credito:           { impact: ["N"],      financial: ["R"] },
          investimenti:      { impact: ["N", "P"], financial: ["R"] },
          distributori:      { impact: [],         financial: [] },
        },
      },
      {
        sottotema: "Equal treatment and opportunities for all",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: "NA",
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: ["N"], financial: ["R"] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS S3 — Affected communities",
    sottotemi: [
      {
        sottotema: "Communities’ economic, social and cultural rights",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: ["P"], financial: [] },
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: [],    financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS S4 — Consumers and end-users",
    sottotemi: [
      {
        sottotema: "Impacts related to information for consumers and/or end-users",
        celle: {
          fornitori:         { impact: ["N"], financial: [] },
          operazioniProprie: { impact: ["N"], financial: ["R"] },
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: ["N"], financial: ["R"] }, // (?)
          distributori:      { impact: ["N"], financial: ["R"] }, // (?)
        },
      },
      {
        sottotema: "Social inclusion of consumers and/or end-users",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: ["N"], financial: ["R"] },
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: [],    financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS G1 — Business conduct",
    sottotemi: [
      {
        sottotema: "Corporate culture",
        celle: {
          fornitori:         "NA",
          operazioniProprie: { impact: ["N", "P"], financial: ["R"] },
          sottoscrizione:    "NA",
          credito:           "NA",
          investimenti:      "NA",
          distributori:      "NA",
        },
      },
      {
        sottotema: "Whistleblower protection",
        celle: {
          fornitori:         { impact: [], financial: [] },
          operazioniProprie: { impact: [], financial: ["R"] },
          sottoscrizione:    { impact: [], financial: [] },
          credito:           { impact: [], financial: [] },
          investimenti:      { impact: [], financial: [] },
          distributori:      { impact: [], financial: [] },
        },
      },
      {
        sottotema: "Management of relationships with suppliers, including payment practices",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: [],    financial: [] },
          sottoscrizione:    { impact: ["N"], financial: [] }, // (?) column to confirm
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: [],    financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
      {
        sottotema: "Corruption and bribery",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: [],    financial: ["R"] },
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: ["N"], financial: ["R"] }, // (?)
          distributori:      { impact: ["N"], financial: ["R"] }, // (?)
        },
      },
    ],
  },
];
